import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import ActiveResidenceBookingsRow from './ActiveResidenceBookingsRow'
import moment from 'moment'

import { Bookings, Heading, SubHeading, BookingInfo } from './ActiveResidenceBookingsStyle'

@inject('residenceBookingStore')

@observer
class ActiveResidenceBookings extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cancel: false,
    }
    this.openCancelModal = this.openCancelModal.bind(this)
  }

  // Check https://github.com/mobxjs/mobx-react/blob/master/README.md#faq
  // to see why I did this (componentWillMount())
  // To replicate the error that occurs otherwise put
  // this.props.bookingStore.getActiveBookings()
  // into the constructor and see what happens.

  componentWillMount() {
    this.props.residenceBookingStore.getActiveBookings()
  }

  openCancelModal() {
    this.cancelmodal.openModal();
  }

  render() {
    const { isActiveBookings, activeBookings } = this.props.residenceBookingStore;

    let noPastBooking = []

    return (
      <Bookings style={{ marginTop: 45, marginBottom: 45, paddingBottom: 35 }}>
        <Heading style={{ paddingLeft: 15 }}>IHRE AUFENTHALTE</Heading>
        <SubHeading>
          bevorstehend
        </SubHeading>
        <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>
        {!isActiveBookings
          ? <BookingInfo style={{ marginLeft: 15 }}>Momentan keine Buchungen.</BookingInfo>
          : activeBookings.map((booking, key) => {
            if (moment(booking.bookingEnd.iso).isAfter(moment())) {
              return <ActiveResidenceBookingsRow booking={booking} key={key} />
            }
            return ""
          }
          )
        }
        <SubHeading>
          vergangen
        </SubHeading>
        <div style={{ marginLeft: 15, borderBottom: "1px solid rgb(33,45,61,15%)", width: "25%", marginBottom: 10 }}></div>
        {!isActiveBookings
          ? <BookingInfo style={{ marginLeft: 15 }}>Momentan keine Buchungen.</BookingInfo>
          : activeBookings.map((booking, key) => {
            if (moment(booking.bookingEnd.iso).isSameOrBefore(moment())) {
              return <ActiveResidenceBookingsRow isPast={true} booking={booking} key={key} />
            } else {
              if (noPastBooking.length < 1) {
                noPastBooking.push(<BookingInfo style={{ marginLeft: 15 }}>Keine vergangenen Buchungen</BookingInfo>)
              }
            }
            return ""
          }
          )
        }
        {noPastBooking.length > 0
          ? noPastBooking
          : ''}
      </Bookings>
    )
  }
}

ActiveResidenceBookings.propTypes = {
  residenceBookingStore: MobxPropTypes.observableObject,
  activeBookings: MobxPropTypes.observableArray,
};

export default ActiveResidenceBookings;



// WEBPACK FOOTER //
// /src/components/internal/Residence/ActiveResidenceBookings.js